import { ReactElement } from 'react'
import { Heading } from '../../Atoms'
import { SearchResultHeadingProps } from './props'

const SearchResultHeading = ({
    title,
}: SearchResultHeadingProps): ReactElement => (
    <Heading
        css={{
            fontSize: 16,
            mb: 10,
            color: '$neutral500',
        }}
        bold
        italic
        level={6}
    >
        {title}
    </Heading>
)

export default SearchResultHeading
